import Meta from 'components/Meta'
import { PageHeading } from 'components/PageHeading'
// import { ShowNotes } from 'components/Templates/ShowNotes'
import ToastyLayout from 'components/ToastyLayout'
import { requireAuth } from 'util/auth'

function ShowNotesPage() {
  return (
    <>
      <Meta title="Generate Show Notes | Outcast" />
      <ToastyLayout current="/content-writer">
        <PageHeading
          title="Generate Show Notes"
          description="Craft a perfectly formatted show notes document for your episode."
        />
        {/* <ShowNotes /> */}
      </ToastyLayout>
    </>
  )
}

export default requireAuth(ShowNotesPage)
